
import React from 'react';
import PageLayout from './src/components/PageLayout';


export function wrapPageElement({ element, props }) {
  return <PageLayout {...props}>{element}</PageLayout>;
}